// Wording for the Client Delivery Wizard's "Update Lead Status" step after a Marketo send
// (Backlog #214, 2026-10-23). Marketo has no business verdict: a failed push is a technical
// problem (duplicate record, value too long, routing...), so the backend leaves those leads
// untouched, still in the wizard, instead of marking them rejected by the client. This says so.

// Shown before the button is clicked.
export function marketoPromptText(delivered, failed) {
  const d = delivered || 0;
  const f = failed || 0;
  let text = `Marketo already confirmed these results: ${d} accepted, ${f} failed.`;
  if (f > 0) text += ' Failed leads are left as they are, so you can fix them and send again.';
  text += ' Update NeTrA\'s lead status now instead of waiting on Check Feedback?';
  return text;
}

// Shown once the update has been applied. `result` is the endpoint's body.
export function marketoAppliedText(result) {
  const accepted = (result && result.accepted) || 0;
  const failed = (result && result.failed) || 0;
  let text = `✓ Lead status updated: ${accepted} accepted`;
  text += failed > 0 ? `, ${failed} failed and left unchanged (fix them and send again).` : '.';
  return text;
}

// One line per failed lead, capped so a big failure does not flood the page.
export function failedLeadLines(result, max = 10) {
  const leads = (result && result.failed_leads) || [];
  const lines = leads.slice(0, max).map(l => `${l.lead_id}${l.email ? ` (${l.email})` : ''}: ${l.reason}`);
  if (leads.length > max) lines.push(`…and ${leads.length - max} more`);
  return lines;
}
